// extracted by mini-css-extract-plugin
module.exports = {"service":"_4f720283bf--service--haatC"};